import withNavigate from "../../../routes/withNavigate.jsx";
import ProductsContainer from "./ProductsContainer.jsx";
import ProductsStore from "./ProductsStore.js";

export default ProductsStore(withNavigate(ProductsContainer)); 